import type { IconSvgObject } from './types';

const ChromeIcon: IconSvgObject = [
  ["circle", { cx: "12", cy: "12", r: "10", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["circle", { cx: "12", cy: "12", r: "4", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M8.53448 14L4.0332 6", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M11.5 21.5L15.5 14", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "3" }],
  ["path", { d: "M12 8H21", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "4" }]
];

export default ChromeIcon;
